<template>
  <div class="response_table" >
    <div class="header">
      <label>
        {{ translate('specification.production_plan') }}
        ({{ items_list.length > 0 ? items_list.length : translate('empty') }})
      </label>

      <label>
        {{ items_list.length > 0 ? global_qty : "" }}
      </label>

      <div class="buttons">
        <router-link
            v-if="has_client_orders"
            :to="'/production/order_list?&client_order_spec_id=' + specification_id"
        >
          <button class="btn-info btn-fill btn-wd">
            {{ translate("specification.order_history") }}
          </button>
        </router-link>
        <button
            class="btn-success btn-fill btn-wd"
            @click="add_position()"
        >
          {{ translate("specification.new_item") }}
        </button>
      </div>


    </div>

    <table v-if="items_list.length > 0">
      <thead>
        <tr>
          <th
              class="pointer"
              @click="change_filter('device_sku_id')"
              :class="{ selected: filter_type === 'device_sku_id' }"
              scope="col"
          >
            {{ translate('specification.position.device_sku') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer"
              @click="change_filter('qty_required')"
              :class="{ selected: filter_type === 'qty_required' }"
              scope="col"
          >
            {{ translate('specification.position.qty') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer"
              @click="change_filter('equipment')"
              :class="{ selected: filter_type === 'equipment' }"
              scope="col"
          >
            {{ translate('specification.position.equipment') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer"
              @click="change_filter('descr')"
              :class="{ selected: filter_type === 'descr' }"
              scope="col"
          >
            {{ translate('specification.position.description') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer"
              @click="change_filter('planned_finish_date')"
              :class="{ selected: filter_type === 'planned_finish_date' }"
              scope="col"
          >
            {{ translate('specification.position.planned_date') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th
              class="pointer"
              @click="change_filter('closed_at')"
              :class="{ selected: filter_type === 'closed_at' }"
              scope="col"
          >
            {{ translate('specification.position.closed_at') }}
            <i
                class="mdi mdi-arrow-down"
                :class="{ reverse: filter_asc === 'desc' }"
            />
          </th>

          <th class="w50" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="(item, key) in production_plan"
            :key="key"
            class="item"
            @click="edit_position(item)"
        >
          <td :data-label="translate('specification.position.device_sku')" class="text-left">
            {{ get_device_sku(item.device_sku_id) }}
            <span class="mdi mdi-magnify pointer" @click.prevent.stop="show_device_sku(item.device_sku_id)" />
          </td>
          <td :data-label="translate('specification.position.qty')" >
            {{ `${item.qty_produced} / ${item.qty_required}` }}
          </td>
          <td :data-label="translate('specification.position.equipment')" class="text-left">
            <div class="equipment-clamp">
              {{ item.equipment }}
            </div>
          </td>
          <td :data-label="translate('specification.position.description')" class="text-left">
            {{ item.descr }}
          </td>
          <td :data-label="translate('specification.position.planned_date')" >
            {{ date_transform(item.planned_finish_date, ".") }}
          </td>
          <td :data-label="translate('specification.position.closed_at')" :class="get_closed_date(item.planned_finish_date_ts, item.closed_at)">
            {{ item.closed_at ? get_date(item.closed_at) : "" }}
          </td>
          <td class="w50" @click.prevent.stop="">
            <div class="control">
              <div class="left">
                <span
                    v-if="!(Number(item.qty_produced) >= Number(item.qty_required))"
                    class="mdi mdi-briefcase"
                    @click="work_order(item)"
                />
              </div>
              <div class="right">
                <router-link
                    v-if="item.has_client_orders"
                    :to="'/production/order_list?&client_order_spec_item_id=' + item.id"
                >
                  <span class="mdi mdi-magnify" />
                </router-link>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script >

import EditPosition from "./Modal/EditPosition.vue";
import ProductionFromPlan from "./Modal/ProductionFromPlan.vue";
import DeviceSkuInfo from "components/UIComponents/DeviceSku/DeviceSkuInfo.vue";

export default {
  name: "SpecificationItemsList",
  props: {
    items_list: {
      type: [Object, Array],
      required: true
    },
    specification_id: {
      type: [Number],
      required: true
    },
    has_client_orders:{
      type: [Boolean],
      required: true
    }
  },

  data () {
    return {
      filter_asc: "asc",
      filter_type: ""
    }
  },

  computed: {
    global_qty () {
      const totals = this.items_list.reduce((acc, item) => {
        acc.produced += Number(item.qty_produced) || 0
        acc.required += Number(item.qty_required) || 0
        return acc
      }, {
        produced: 0,
        required: 0
      })

      const percent = totals.required ? ((totals.produced / totals.required) * 100).toFixed(2) : '0.00'
      return `${totals.produced} из ${totals.required} - ${percent}%`
    },
    production_plan() {
      let production_plan = [...this.items_list];
      return production_plan.sort(this.compareNumbers);
    }
  },

  methods:{
    show_device_sku(id){
      this.$http.v1.getDeviceSkuInfo(id, (response) => {
        if (response.data){
          let t = this.$createElement(DeviceSkuInfo, {
            props: {
              device_sku: response.data
            },
            on: {
              close: () => {
                this.$modal.hide('device_sku_info_modal')
              }
            }
          })
          let temp = { render() { return t } }
          this.$modal.show(temp, {}, {
            height: 'auto',
            width: 900,
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'device_sku_info_modal'
          })
        }
      })
    },
    get_closed_date(planned_finish_date, closed_at) {
      if (!closed_at) return ""
      const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
      const diff = Number(closed_at) - Number(planned_finish_date);

      if (diff <= 0) {
        return 'success-light';
      }

      if (diff <= WEEK_MS) {
        return 'warning-light';
      }

      return 'danger-light';
    },
    work_order(item){
      let t = this.$createElement(ProductionFromPlan, {
        props: {
          device_sku: this.get_device_sku(item.device_sku_id),
          max_qty: Number(item.qty_required) - Number(item.qty_produced),
          client_order_spec_item_id: item.id
        },
        on: {
          update: () => {
            this.$modal.hide("production_from_plan_modal");
          },
          close: () => {
            this.$modal.hide("production_from_plan_modal");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "production_from_plan_modal",
          }
      );
    },
    add_position(){
      this.edit_position({})
    },
    edit_position(position){
      let t = this.$createElement(EditPosition, {
        props: {
          position,
          specification_id: this.specification_id
        },
        on: {
          update: () => {
            this.$modal.hide("new_position_modal");
            this.$emit("update_info")
          },
          close: () => {
            this.$modal.hide("new_position_modal");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "new_position_modal",
          }
      );
    },
    get_device_sku(device_sku_id){
      const sku = this.$store.getters.getDeviceSkus.find(item => {
        if(device_sku_id === item.id){
          return item
        }
      })
      return sku ? sku.name : ""
    },
  }
}

</script>

<style lang="scss" scoped>
.response_table{
  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    label{
      margin: 0;
    }
    .buttons{
      display: flex;
      gap: 5px;
    }
  }
  table{
    font-size: 12px;
  }
  .pointer{
    cursor: pointer;
  }
  .item{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
    .text-left{
      text-align: left;
      padding: 0 5px;
    }
    .control{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 5px;
      .left, .right{
        flex: 1;
      }

      .mdi{
        font-size: 16px;
        line-height: 120%;
      }
    }
    .equipment-clamp {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      word-break: break-word;
    }

    .success-light {
      background: #d9f2d9;
    }

    .warning-light {
      background: #ffe7cc;
    }

    .danger-light {
      background: #f8d7da;
    }
  }
}
</style>
